export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    getPhoneCodeList: function getPhoneCodeList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/phone_prefix/get",
        method: "get",
        params: data
      });
    },
    addPhoneCode: function addPhoneCode() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/phone_prefix/create",
        method: "post",
        data: data
      });
    },
    updatePhoneCode: function updatePhoneCode() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/phone_prefix/update",
        method: "post",
        data: data
      });
    },
    getAllPhoneCodeList: function getAllPhoneCodeList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "api/user/getPhonePrefixList",
        method: "get",
        params: data
      });
    }
  };
});